export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/environments/environment.prod.ts